import * as React from "react"
import {useEffect} from "react"
import {Box} from "@mui/material";

import {PRODUCTS_MATCHER_ROUTES} from "@constants";
import PageWrapper from "../../@PageWrapper";
import {MatchersSkeleton} from "../@components";
import {useProductsMatcherItems} from "./@hooks";
import {clearProductsMatcherSignals, isProductsMatcherLoading} from "./@signals";
import ProductsMatcherContent from "./Content";
// Reuse the audit raw2raw group editor (members + unmap) for the "already matched to" drawer
import AuditEditMappingDrawer from "../../AuditLog/EditMappingDrawer";
import AuditImageComparisonModal from "../../AuditLog/EditMappingDrawer/ImageComparisonModal";


export default function ProductsMatcherPage() {
	const { handleSubmit } = useProductsMatcherItems()

	useEffect(() => {
		const params = new URLSearchParams(window.location.search)
		const idMapping = params.get('id_mapping')
		handleSubmit(idMapping)
		return clearProductsMatcherSignals
	}, [])

	return <PageWrapper head={`Products Mapper | ${PRODUCTS_MATCHER_ROUTES.PRODUCTS_SUBTITLE}`} title={PRODUCTS_MATCHER_ROUTES.PRODUCTS_SUBTITLE}>
		<Box width={1} height={1} position="relative" top={20}>
			{ isProductsMatcherLoading.value
				? <MatchersSkeleton />
				: <ProductsMatcherContent hasIdMapping={new URLSearchParams(window.location.search).get('id_mapping') !== null} />
			}
		</Box>
		<AuditEditMappingDrawer />
		<AuditImageComparisonModal />
	</PageWrapper>
}